import { render, staticRenderFns } from "./annual-invalid-registered-coach.vue?vue&type=template&id=81326f4c&scoped=true&"
import script from "./annual-invalid-registered-coach.vue?vue&type=script&lang=js&"
export * from "./annual-invalid-registered-coach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81326f4c",
  null
  
)

export default component.exports